/* eslint-env browser, es6 */
import m from "mithril";

import { Board, Cell } from "../board";
import { BLANK_CHARACTER, BOARD_SIZE } from "../constants";

interface BoardViewAttrs {
  board: Board;
}

export class BoardView implements m.Component<BoardViewAttrs> {
  private board: Board;

  constructor(vnode: m.Vnode<BoardViewAttrs>) {
    this.board = vnode.attrs.board;
  }

  view(): m.Children {
    const rows = Array.from(
      this.board.rows().map((row) => {
        return row.map((cell: Cell) =>
          m(
            "span.letter",
            {
              style: getLetterColorCss(cell.highlightIndex),
            },
            cell.letter
          )
        );
      })
    );

    return m("div.board", rows);
  }
}

interface FinishedBoardViewAttrs {
  board: Board;
}

export class FinishedBoardView implements m.Component<FinishedBoardViewAttrs> {
  private board: Board;

  constructor(vnode: m.Vnode<FinishedBoardViewAttrs>) {
    this.board = vnode.attrs.board;
  }

  view(): m.Children {
    return m(
      "div.board.finished",
      this.board.rows().map((row) => {
        return row.map((cell: Cell) => {
          return m("span.letter", cell.letter);
        });
      })
    );
  }
}

export class EmptyBoardView implements m.Component {
  view(): m.Children {
    const blankElements = [];
    for (let i = 0; i < BOARD_SIZE * BOARD_SIZE; i++) {
      blankElements.push(m("span.letter", BLANK_CHARACTER));
    }

    return m("div.board", blankElements);
  }
}

function getLetterColorCss(highlightIndex: number | null): string {
  if (highlightIndex === null) {
    return "";
  }

  const colorStrength = Math.max(1 - highlightIndex / 6, 0.2);
  return `color: rgb(255, 0, 0, ${colorStrength});`;
}
